import { createSelector } from '@ngrx/store';

import * as fromFeature from '../../reducers/index';
import * as fromSelectedClientAccounts from '../../reducers/selected-client-accounts/selected-client-accounts.reducer';

export const selectedClientAccountsState = createSelector(
  fromFeature.getSelectedClientAccountsState,
  (state) => state,
);

export const selectedAccountsFrom = createSelector(
  selectedClientAccountsState,
  fromSelectedClientAccounts.getSelectedAccountsFrom,
);
export const selectedAccountTo = createSelector(
  selectedClientAccountsState,
  fromSelectedClientAccounts.getSelectedAccountTo,
);

export const selectTransactionType = createSelector(
  selectedClientAccountsState,
  fromSelectedClientAccounts.getTransactionType,
);

export const selectIraType = createSelector(
  selectedClientAccountsState,
  fromSelectedClientAccounts.getIraType,
);
export const selectIraOption = createSelector(
  selectedClientAccountsState,
  fromSelectedClientAccounts.getIraOption,
);

export const selectAsOfDateFromSelectedAccountsFrom = createSelector(
  selectedClientAccountsState,
  fromSelectedClientAccounts.getAsOfDateFromSelectedAccountsFrom,
);
